<script>
import axiosUtil from '@/util/axiosUtil';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {
    document.title = this.$t('message.bandName');
    axiosUtil.count();
    this.init();
  },
  mounted() {
  },
  methods: {
    init() {
      this.ready = false;

      setTimeout(()=> {
        this.ready = true;
      }, 1);
    },
  },

};
</script>

<template>
  <div
    id="app"
    class="wf-sawarabimincho"
    :class="$mq"
  >
    <div
    class="app-container"
      v-if="ready"
    >
      <transition name="router-transition" mode="out-in">
        <router-view/>
      </transition>
    </div>

    <div
      class="app-load"
      v-if="!ready"
    >
    </div>

    <!--font-->
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Sawarabi+Mincho&display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap" rel="stylesheet">
    
  </div>
</template>

<style lang="scss">
  @import "./css/reset.css";
  @import "./css/webFont.css";
  @import "./css/main";
  @import "./css/variables";
  .page {
    @include bgCenter;
    background-size: cover;
    background-image: url(assets/img/decoration/bg.svg);
    background-attachment: fixed;
  }

  // 遷移Animation from 
  .router-transition-leave {
    opacity: 1;
  }
  .router-transition-leave-to {
    opacity: 0;

    &.page.view-index  { // top
      &.is-ready{
        .bg-container {
          .origin {
            transform: rotate(30deg) scale(1.5);
          }
        }
        .contents-container {
          .band-logo {
            transform: scale(1.5);
          }
        }
      }
    }

  }
  .router-transition-leave-active {
     transition: 0.5s ease;
    &.page.view-index  { // top
      transition: 2s ease;
      &.is-ready{
        .bg-container {
          .origin {
            transition: 2s ease;
          }
        }
      }
    }
  }

  // 遷移Animation to
  .router-transition-enter {
    // transform: scale(0.9);
    opacity: 0;
  }
  .router-transition-enter-to {
    opacity: 1;
  }
  .router-transition-enter-active {
    transition: 0.5s ease;
  }

  // Jacket -------------------------------------------
  .is-album-jacket-10 { background-image: url(assets/img/discography/10/m.jpg); }
  .is-album-jacket-11 { background-image: url(assets/img/discography/11/m.jpg); }
  .is-album-jacket-12 { background-image: url(assets/img/discography/12/m.jpg); }
  .is-album-jacket-13 { background-image: url(assets/img/discography/13/m.jpg); }
  .is-album-jacket-14 { background-image: url(assets/img/discography/14/m.jpg); }
  .is-album-jacket-15 { background-image: url(assets/img/discography/15/m.jpg); }

  // バナー ----------------------------------------------
  .banner200x40 {
    &.akibao {background-image: url(assets/img/banner/company/akibao.png);}
    &.amazon {background-image: url(assets/img/banner/company/amazon.png);}
    &.amazonDigitalMusicStore {background-image: url(assets/img/banner/company/amazonDigitalMusicStore.png);}
    &.amazonMusicUnlimited {background-image: url(assets/img/banner/company/amazonMusicUnlimited.png);}
    &.anghami {background-image: url(assets/img/banner/company/anghami.png);}
    &.animeloMix {background-image: url(assets/img/banner/company/animeloMix.png);}
    &.appleMusic {background-image: url(assets/img/banner/company/appleMusic.png);}
    &.awa {background-image: url(assets/img/banner/company/awa.png);}
    &.bandcamp {background-image: url(assets/img/banner/company/bandcamp.png);}
    &.booth {background-image: url(assets/img/banner/company/booth.png);}
    &.deezer {background-image: url(assets/img/banner/company/deezer.png);}
    &.dHits {background-image: url(assets/img/banner/company/dHits.png);}
    &.diskUnion {background-image: url(assets/img/banner/company/diskUnion.png);}
    &.dlSiteCom {background-image: url(assets/img/banner/company/dlSiteCom.png);}
    &.dMusic {background-image: url(assets/img/banner/company/dMusic.png);}
    &.dwangoJp {background-image: url(assets/img/banner/company/dwangoJp.png);}
    &.facebookMusicStamp {background-image: url(assets/img/banner/company/facebookMusicStamp.png);}
    &.gracenote {background-image: url(assets/img/banner/company/gracenote.png);}
    &.gyutto {background-image: url(assets/img/banner/company/gyutto.png);}
    &.instagramMusicStamp {background-image: url(assets/img/banner/company/instagramMusicStamp.png);}
    &.iTunesStore {background-image: url(assets/img/banner/company/iTunesStore.png);}
    &.jioSaavn {background-image: url(assets/img/banner/company/jioSaavn.png);}
    &.kkBox {background-image: url(assets/img/banner/company/kkBox.png);}
    &.lineMusic {background-image: url(assets/img/banner/company/lineMusic.png);}
    &.melonbooks {background-image: url(assets/img/banner/company/melonbooks.png);}
    &.melonbooksDl {background-image: url(assets/img/banner/company/melonbooksDl.png);}
    &.mixcloud {background-image: url(assets/img/banner/company/mixcloud.png);}
    &.mucome {background-image: url(assets/img/banner/company/mucome.png);}
    &.musicStore {background-image: url(assets/img/banner/company/musicStore.png);}
    &.otoraku {background-image: url(assets/img/banner/company/otoraku.png);}
    &.pandora {background-image: url(assets/img/banner/company/pandora.png);}
    &.popo {background-image: url(assets/img/banner/company/popo.png);}
    &.rakutenMusic {background-image: url(assets/img/banner/company/rakutenMusic.png);}
    &.recochoku {background-image: url(assets/img/banner/company/recochoku.png);}
    &.shazam {background-image: url(assets/img/banner/company/shazam.png);}
    &.soundCloud {background-image: url(assets/img/banner/company/soundCloud.png);}
    &.spotify {background-image: url(assets/img/banner/company/spotify.png);}
    &.tikTok {background-image: url(assets/img/banner/company/tikTok.png);}
    &.towerRecordsMusic {background-image: url(assets/img/banner/company/towerRecordsMusic.png);}
    &.unitedMediaAgency {background-image: url(assets/img/banner/company/unitedMediaAgency.png);}
    &.utaPass {background-image: url(assets/img/banner/company/utaPass.png);}
    &.yandexMusic {background-image: url(assets/img/banner/company/yandexMusic.png);}
    &.youtubeMusic {background-image: url(assets/img/banner/company/youtubeMusic.png);}

    &.distribution-banner {background-image: url(assets/img/common/streaming.png);}
  }

  // load -----------------------------------------------
  .app-load {
    @include absolute100;
  }
</style>
